  
import * as types from './mutation-types'

export default {
  [types.PRE_CART_ITENS] (state, payload) {
    state.pre_cart_itens = payload
  },
  [types.PRE_CART_TOTAL] (state, payload) {
    state.pre_cart_total = payload
  },
  [types.CART] (state, payload) {
    state.cart = payload
  },
  [types.DELETE_CART] (state) {
    state.cart = {}
  },
  [types.DELETE_PRE_CART_TOTAL] (state) {
    state.pre_cart_total = 0
  },
  [types.DELETE_CART_ITENS] (state) {
    state.pre_cart_itens = 0
  },
}